import { TrueworkJsStrategy } from '@frame/lib/api/tasks/types'

import { useStore } from '../stores/useStore'
import { isBilStrategy, isNotBank, isNotDocuments } from '../utils/tasks'

const STRATEGY_ORDER = [TrueworkJsStrategy.BANK, TrueworkJsStrategy.CREDENTIALS, TrueworkJsStrategy.DOCUMENTS]

export function useStrategies() {
  const enabledStrategies = useStore((state) => state.session?.configuration.enabled_strategies ?? [])
  const bilEnabledStrategies = enabledStrategies.filter(isBilStrategy)
  const sortedBilEnabledStrategies = bilEnabledStrategies.sort(
    (a, b) => STRATEGY_ORDER.indexOf(a) - STRATEGY_ORDER.indexOf(b)
  )
  const isMultiStrategy = bilEnabledStrategies.length > 1
  const documentsEnabled = bilEnabledStrategies.includes(TrueworkJsStrategy.DOCUMENTS)
  const credentialsEnabled = bilEnabledStrategies.includes(TrueworkJsStrategy.CREDENTIALS)
  const bankEnabled = bilEnabledStrategies.includes(TrueworkJsStrategy.BANK)
  const instantEnabled = enabledStrategies.includes(TrueworkJsStrategy.INSTANT)
  const irsEnabled = enabledStrategies.includes(TrueworkJsStrategy.IRS)
  const bilEnabledStrategiesNoBank = sortedBilEnabledStrategies.filter(isNotBank) ?? []
  const bilEnabledStrategesNoDocuments = bilEnabledStrategies.filter(isNotDocuments) ?? []

  const strategies = {
    isMultiStrategy,
    documentsEnabled,
    instantEnabled,
    credentialsEnabled,
    bankEnabled,
    irsEnabled,
  }

  return {
    ...strategies,
    bilEnabledStrategies,
    isSingleStrategy: bilEnabledStrategies.length === 1,
    bilEnabledStrategiesNoBank,
    bilEnabledStrategesNoDocuments,
  }
}
